// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__6xKiD","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1BKD1"};